import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx } from "vue"

import { useVModel } from '@vueuse/core'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: [String, Number]
  },
  view: {
    type: Boolean
  },
  placeholder: {
    type: String
  },
  cosType: {
    type: String
  }
},
  emits: ['update:value'],
  setup(__props, { emit: __emit }) {

const props = __props
// const valueView = computed(() => {
//   /// 这里针对金额来判断是否需要千位分隔法，但是要注意小数点
//   if (props.cosType === 'money') {
//     const value = (props.value ?? '').toString()
//     if (value) {
//       const parts = value.split('.')
//       let floatPart = ''
//       parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//       if (value.includes('.')) { // 有小数部分
//         floatPart = parts[1].toString() // 取得小数部分
//         return parts[0] + '.' + floatPart
//       }
//       return parts[0] + floatPart
//     }
//     return value
//   }
//   return props.value
// })

// const value = 1234.5678
// const formattedValue = value.toLocaleString('en-US', { maximumFractionDigits: 2 })
// console.log(formattedValue) // 输出 "1,234.57"

// const value = 1234.5
// const formattedValue = value.toLocaleString('en-US', { minimumFractionDigits: 2 })
// console.log(formattedValue) // 输出 "1,234.50"

// const value = 1234.5
// const formattedValue = value.toLocaleString('en-US', {
//   minimumFractionDigits: 2,
//   maximumFractionDigits: 2
// })
// console.log(formattedValue) // 输出 "1,234.50"

/// 针对千位分割法处理（如果需要针对两位小数那么可以添加上面注释的方法）
const valueView = computed(() => {
  if (props.cosType === 'money') {
    if (!props.value) {
      return ''
    }
    const value = Number(props.value)
    if (isNaN(value)) {
      return ''
    }
    return value.toLocaleString('en-US', { maximumFractionDigits: 2 })
  }
  return props.value
})

const emit = __emit
const modelValue = useVModel(props, 'value', emit)

return (_ctx: any,_cache: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (__props.view)
    ? (_openBlock(), _createBlock(CosInputView, _mergeProps({
        key: 0,
        value: valueView.value
      }, _ctx.$attrs, { cosType: __props.cosType }), null, 16, ["value", "cosType"]))
    : (_openBlock(), _createBlock(_component_a_input_number, _mergeProps({ key: 1 }, _ctx.$attrs, {
        placeholder: __props.placeholder || _ctx.$t('common.pleaseInput'),
        value: _unref(modelValue),
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
        style: {"width":"100%"}
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "addonBefore"),
          _renderSlot(_ctx.$slots, "addonAfter")
        ]),
        _: 3
      }, 16, ["placeholder", "value"]))
}
}

})